import React from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/font-awesome.min.css';
import '../assets/css/fontawesome-stars-o.min.css';
import '../assets/css/responsive-style.css';
import '../assets/css/colors/theme-color-1.css';
import '../assets/css/custom.css';
import '../assets/css/home.css';
import '../assets/css/owl.carousel.min.css';

const Contact = () => {
  return (
    <div>
  {/* Posts Filter Bar Start */}
  <div className="posts--filter-bar style--1 hidden-xs">
    <div className="container">
      <ul className="nav">
        <li>
          <a href="#">
            <i className="fa fa-star-o" />
            <span>Featured News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-heart-o" />
            <span>Most Popular</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-fire" />
            <span>Hot News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-flash" />
            <span>Trending News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-eye" />
            <span>Most Watched</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  {/* Posts Filter Bar End */}
  {/* News Ticker Start */}
  <div className="news--ticker">
    <div className="container">
      <div className="title">
        <h2>News Updates</h2>
        <span>(Update 12 minutes ago)</span>
      </div>
      <div className="news-updates--list" data-marquee="true">
        <ul className="nav">
          <li>
            <h3 className="h3"><a href="#">Contrary to popular belief Lorem Ipsum is not simply random text.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Education to popular belief Lorem Ipsum is not simply</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Lorem ipsum dolor sit amet consectetur adipisicing elit.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Corporis repellendus perspiciatis reprehenderit.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Deleniti consequatur laudantium sit aspernatur?</a></h3>
          </li>
        </ul>
      </div>
    </div>
  </div>
  {/* News Ticker End */}
  {/* Main Breadcrumb Start */}
  <div className="main--breadcrumb">
    <div className="container">
      <ul className="breadcrumb">
        <li><a href="home-1.html" className="btn-link"><i className="fa fm fa-home" />Home</a></li>
        <li className="active"><span>Author</span></li>
      </ul>
    </div>
  </div>
  {/* Main Breadcrumb End */}
  {/* Main Content Section Start */}
  <div className="main-content--section pbottom--30">
    <div className="container">
      <div className="row">
        {/* Main Content Start */}
        <div className="main--content col-md-8 col-sm-7" data-sticky-content="true">
          <div className="sticky-content-inner">
            {/* Post Author Info Start */}
            <div className="post--author-info clearfix">
              <div className="img">
                <div className="vc--parent">
                  <div className="vc--child">
                    <img src="img/news-single-img/author.jpg" alt />
                    <p className="name">Karla Gleichauf</p>
                  </div>
                </div>
              </div>
              <div className="info">
                <h2 className="h4">About The Author</h2>
                <div className="content">
                  <p>That is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has ab more  normal distribution of letters, as opposed to using content here.</p>
                </div>
                <ul className="social nav">
                  <li><a href="#"><i className="fa fa-facebook" /></a></li>
                  <li><a href="#"><i className="fa fa-twitter" /></a></li>
                  <li><a href="#"><i className="fa fa-google-plus" /></a></li>
                  <li><a href="#"><i className="fa fa-rss" /></a></li>
                </ul>
              </div>
            </div>
            {/* Post Author Info End */}
            {/* Post Items Start */}
            <div className="post--items post--items-5 pd--30-0">
              <ul className="nav">
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4 col-sm-12 col-xs-4 col-xxs-12">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-01.jpg" alt /></a>
                          <a href="#" className="cat">Kids</a>
                        </div>
                      </div>
                      <div className="col-md-8 col-sm-12 col-xs-8 col-xxs-12">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Bushyasta</a></li>
                            <li><a href="#">16 April 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Credibly pontificate highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4 col-sm-12 col-xs-4 col-xxs-12">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-02.jpg" alt /></a>
                          <a href="#" className="cat">War</a>
                        </div>
                      </div>
                      <div className="col-md-8 col-sm-12 col-xs-8 col-xxs-12">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Chemosh</a></li>
                            <li><a href="#">05 March 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Credibly pontificate highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4 col-sm-12 col-xs-4 col-xxs-12">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-03.jpg" alt /></a>
                          <a href="#" className="cat">Fashion</a>
                        </div>
                      </div>
                      <div className="col-md-8 col-sm-12 col-xs-8 col-xxs-12">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Focalor</a></li>
                            <li><a href="#">19 January 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Credibly pontificate highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4 col-sm-12 col-xs-4 col-xxs-12">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-04.jpg" alt /></a>
                          <a href="#" className="cat">Foods</a>
                        </div>
                      </div>
                      <div className="col-md-8 col-sm-12 col-xs-8 col-xxs-12">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Bune</a></li>
                            <li><a href="#">16 April 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Credibly pontificate highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
              </ul>
            </div>
            {/* Post Items End */}
            {/* Advertisement Start */}
            <div className="ad--space">
              <a href="#">
                <img src="img/ads-img/ad-728x90-02.jpg" alt className="center-block" />
              </a>
            </div>
            {/* Advertisement End */}
            {/* Post Items Start */}
            <div className="post--items post--items-5 pd--30-0">
              <ul className="nav">
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-05.jpg" alt /></a>
                          <a href="#" className="cat">Old City</a>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Bune</a></li>
                            <li><a href="#">16 April 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Credibly pontificate highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-06.jpg" alt /></a>
                          <a href="#" className="cat">Travel</a>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Krampus</a></li>
                            <li><a href="#">10 September 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Credibly pontificate highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-07.jpg" alt /></a>
                          <a href="#" className="cat">Human</a>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Bune</a></li>
                            <li><a href="#">16 April 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">What are they doing highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-08.jpg" alt /></a>
                          <a href="#" className="cat">Politics</a>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Mara</a></li>
                            <li><a href="#">27 August 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">What are they doing highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-09.jpg" alt /></a>
                          <a href="#" className="cat">Gadgets</a>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Bune</a></li>
                            <li><a href="#">16 April 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">What are they doing highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
              </ul>
            </div>
            {/* Post Items End */}
            {/* Advertisement Start */}
            <div className="ad--space">
              <a href="#">
                <img src="img/ads-img/ad-728x90-03.jpg" alt className="center-block" />
              </a>
            </div>
            {/* Advertisement End */}
            {/* Post Items Start */}
            <div className="post--items post--items-5 pd--30-0">
              <ul className="nav">
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-10.jpg" alt /></a>
                          <a href="#" className="cat">World News</a>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Onoskelis</a></li>
                            <li><a href="#">22 May 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">What are they doing highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--title-larger">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/blog-img/post-11.jpg" alt /></a>
                          <a href="#" className="cat">Sports</a>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="post--info">
                          <ul className="nav meta">
                            <li><a href="#">Bune</a></li>
                            <li><a href="#">16 April 2016</a></li>
                          </ul>
                          <div className="title">
                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">What are they doing highly efficient manufactured products and enabled data.</a></h3>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading...</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
              </ul>
            </div>
            {/* Post Items End */}
            {/* Pagination Start */}
            <div className="pagination--wrapper clearfix bdtop--1 bd--color-2 ptop--60 pbottom--30">
              <p className="pagination-hint float--left">Page 02 of 03</p>
              <ul className="pagination float--right">
                <li><a href="#"><i className="fa fa-long-arrow-left" /></a></li>
                <li><a href="#">01</a></li>
                <li className="active"><span>02</span></li>
                <li><a href="#">03</a></li>
                <li>
                  <i className="fa fa-angle-double-right" />
                  <i className="fa fa-angle-double-right" />
                  <i className="fa fa-angle-double-right" />
                </li>
                <li><a href="#">20</a></li>
                <li><a href="#"><i className="fa fa-long-arrow-right" /></a></li>
              </ul>
            </div>
            {/* Pagination End */}
          </div>
        </div>
        {/* Main Content End */}
        {/* Main Sidebar Start */}
        <div className="main--sidebar col-md-4 col-sm-5 ptop--30 pbottom--30" data-sticky-content="true">
          <div className="sticky-content-inner">
            {/* Widget Start */}
            <div className="widget">
              {/* Search Widget Start */}
              <div className="search--widget">
                <form action="#" data-form="validate">
                  <div className="input-group">
                    <input type="search" name="search" placeholder="Search..." className="form-control" required />
                    <div className="input-group-btn">
                      <button type="submit" className="btn-link"><i className="fa fa-search" /></button>
                    </div>
                  </div>
                </form>
              </div>
              {/* Search Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Catagory</h2>
                <i className="icon fa fa-folder-open-o" />
              </div>
              {/* Nav Widget Start */}
              <div className="nav--widget">
                <ul className="nav">
                  <li><a href="#"><span>Fashion</span><span>(22)</span></a></li>
                  <li><a href="#"><span>Winter</span><span>(16)</span></a></li>
                  <li><a href="#"><span>Exclusive</span><span>(84)</span></a></li>
                  <li><a href="#"><span>Summer</span><span>(11)</span></a></li>
                  <li><a href="#"><span>Heavy Style</span><span>(19)</span></a></li>
                </ul>
              </div>
              {/* Nav Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Tags</h2>
                <i className="icon fa fa-tags" />
              </div>
              {/* Tags Widget Start */}
              <div className="tags--widget style--1">
                <ul className="nav">
                  <li><a href="#">News</a></li>
                  <li><a href="#">Image</a></li>
                  <li><a href="#">Music</a></li>
                  <li><a href="#">Video</a></li>
                  <li><a href="#">Audio</a></li>
                  <li><a href="#">Fashion</a></li>
                  <li><a href="#">Latest</a></li>
                  <li><a href="#">Trendy</a></li>
                  <li><a href="#">Special</a></li>
                  <li><a href="#">Recipe</a></li>
                  <li><a href="#">Sports</a></li>
                </ul>
              </div>
              {/* Tags Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Archives</h2>
                <i className="icon fa fa-folder-open-o" />
              </div>
              {/* Nav Widget Start */}
              <div className="nav--widget">
                <ul className="nav">
                  <li><a href="#"><span>March 2017</span><span>(22)</span></a></li>
                  <li><a href="#"><span>April 2017</span><span>(16)</span></a></li>
                  <li><a href="#"><span>May 2017</span><span>(84)</span></a></li>
                  <li><a href="#"><span>January 2016</span><span>(11)</span></a></li>
                  <li><a href="#"><span>February 2016</span><span>(19)</span></a></li>
                  <li><a href="#"><span>March 2016</span><span>(36)</span></a></li>
                  <li><a href="#"><span>April 2016</span><span>(41)</span></a></li>
                  <li><a href="#"><span>October 2015</span><span>(39)</span></a></li>
                  <li><a href="#"><span>Nover 2015</span><span>(15)</span></a></li>
                  <li><a href="#"><span>Decemberr 2015</span><span>(28)</span></a></li>
                </ul>
              </div>
              {/* Nav Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Stay Connected</h2>
                <i className="icon fa fa-share-alt" />
              </div>
              {/* Social Widget Start */}
              <div className="social--widget style--1">
                <ul className="nav">
                  <li className="facebook">
                    <a href="#">
                      <span className="icon"><i className="fa fa-facebook-f" /></span>
                      <span className="count">521</span>
                      <span className="title">Likes</span>
                    </a>
                  </li>
                  <li className="twitter">
                    <a href="#">
                      <span className="icon"><i className="fa fa-twitter" /></span>
                      <span className="count">3297</span>
                      <span className="title">Followers</span>
                    </a>
                  </li>
                  <li className="google-plus">
                    <a href="#">
                      <span className="icon"><i className="fa fa-google-plus" /></span>
                      <span className="count">596282</span>
                      <span className="title">Followers</span>
                    </a>
                  </li>
                  <li className="rss">
                    <a href="#">
                      <span className="icon"><i className="fa fa-rss" /></span>
                      <span className="count">521</span>
                      <span className="title">Subscriber</span>
                    </a>
                  </li>
                  <li className="vimeo">
                    <a href="#">
                      <span className="icon"><i className="fa fa-vimeo" /></span>
                      <span className="count">3297</span>
                      <span className="title">Followers</span>
                    </a>
                  </li>
                  <li className="youtube">
                    <a href="#">
                      <span className="icon"><i className="fa fa-youtube-square" /></span>
                      <span className="count">596282</span>
                      <span className="title">Subscriber</span>
                    </a>
                  </li>
                </ul>
              </div>
              {/* Social Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Get Newsletter</h2>
                <i className="icon fa fa-envelope-open-o" />
              </div>
              {/* Subscribe Widget Start */}
              <div className="subscribe--widget">
                <div className="content">
                  <p>Subscribe to our newsletter to get  latest news, popular news and exclusive updates.</p>
                </div>
                <form action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d" method="post" name="mc-embedded-subscribe-form" target="_blank" data-form="mailchimpAjax">
                  <div className="input-group">
                    <input type="email" name="EMAIL" placeholder="E-mail address" className="form-control" autoComplete="off" required />
                    <div className="input-group-btn">
                      <button type="submit" className="btn btn-lg btn-default active"><i className="fa fa-paper-plane-o" /></button>
                    </div>
                  </div>
                  <div className="status" />
                </form>
              </div>
              {/* Subscribe Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Featured News</h2>
                <i className="icon fa fa-newspaper-o" />
              </div>
              {/* List Widgets Start */}
              <div className="list--widget list--widget-1">
                {/* Post Items Start */}
                <div className="post--items post--items-3" data-ajax-content="outer">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="#" className="thumb"><img src="img/widgets-img/news-widget-01.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Ninurta</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="#" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="#" className="thumb"><img src="img/widgets-img/news-widget-02.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Orcus</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="#" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="#" className="thumb"><img src="img/widgets-img/news-widget-03.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Rahab</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="#" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="#" className="thumb"><img src="img/widgets-img/news-widget-04.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Tannin</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="#" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* List Widgets End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Advertisement</h2>
                <i className="icon fa fa-bullhorn" />
              </div>
              {/* Ad Widget Start */}
              <div className="ad--widget">
                <a href="#">
                  <img src="img/ads-img/ad-300x250-2.jpg" alt />
                </a>
              </div>
              {/* Ad Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title" data-ajax="tab">
                <h2 className="h4">Readers Opinion</h2>
                <div className="nav">
                  <a href="#" className="prev btn-link" data-ajax-action="load_prev_readers_opinion_widget">
                    <i className="fa fa-long-arrow-left" />
                  </a>
                  <span className="divider">/</span>
                  <a href="#" className="next btn-link" data-ajax-action="load_next_readers_opinion_widget">
                    <i className="fa fa-long-arrow-right" />
                  </a>
                </div>
              </div>
              {/* List Widgets Start */}
              <div className="list--widget list--widget-2" data-ajax-content="outer">
                {/* Post Items Start */}
                <div className="post--items post--items-3">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <span className="thumb">
                            <img src="img/widgets-img/readers-opinion-01.png" alt />
                          </span>
                          <div className="post--info">
                            <div className="title">
                              <h3 className="h4">Long established fact that a reader will be distracted</h3>
                            </div>
                            <ul className="nav meta">
                              <li><span>by Ninurta</span></li>
                              <li><span>16 April 2017</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <span className="thumb">
                            <img src="img/widgets-img/readers-opinion-02.png" alt />
                          </span>
                          <div className="post--info">
                            <div className="title">
                              <h3 className="h4">Long established fact that a reader will be distracted</h3>
                            </div>
                            <ul className="nav meta">
                              <li><span>by Ninurta</span></li>
                              <li><span>16 April 2017</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <span className="thumb">
                            <img src="img/widgets-img/readers-opinion-03.png" alt />
                          </span>
                          <div className="post--info">
                            <div className="title">
                              <h3 className="h4">Long established fact that a reader will be distracted</h3>
                            </div>
                            <ul className="nav meta">
                              <li><span>by Ninurta</span></li>
                              <li><span>16 April 2017</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* List Widgets End */}
            </div>
            {/* Widget End */}
          </div>
        </div>
        {/* Main Sidebar End */}
      </div>
    </div>
  </div>
  {/* Main Content Section End */}
  <div id="backToTop">
                    <a href="#"><i className="fa fa-angle-double-up"></i></a>
                </div>
</div>


  );
};

export default Contact;